import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-roles-dialoge',
  templateUrl: './roles-dialoge.component.html',
  styleUrls: ['./roles-dialoge.component.css']
})
export class RolesDialogeComponent implements OnInit {
  unAssigendRole: any[];
  assigendRoles: any[];

  constructor(public dialogRef: MatDialogRef<RolesDialogeComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.unAssigendRole = this.data.unAssigendRole || [];
    this.assigendRoles = this.data.assigendRoles || [];
    this.loadScript();
  }

  loadScript() {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('link');
    script.href = "./assets/plugins/custom/kanban/kanban.bundle.css"
    script.rel = "stylesheet"
    script.type = 'text/css';
    var oldJs = document.getElementsByTagName('link');
    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      if (element.href.indexOf('kanban.bundle.css') != -1) {
        head.removeChild(element);
        index = index - 1;
      }
    }
    head.appendChild(script);
  }

  save(): void {
    this.dialogRef.close({ unAssigendRole: this.unAssigendRole, assigendRoles: this.assigendRoles });
  }

  close() {
    this.dialogRef.close();
  }

  // assignRole(e: any) {
  //   for (let i = 0; i < this.unAssigendRole.length; i++) {
  //     const unAssRole = this.unAssigendRole[i];
  //     if (unAssRole.id == e.dragData.id) {
  //       this.unAssigendRole.splice(i, 1)
  //     }
  //   }
  //   this.assigendRoles.push(e.dragData);
  // }

  // unAssignRole(e: any) {
  //   for (let i = 0; i < this.assigendRoles.length; i++) {
  //     const unAssRole = this.assigendRoles[i];
  //     if (unAssRole.id == e.dragData.id) {
  //       this.assigendRoles.splice(i, 1)
  //     }
  //   }
  //   this.unAssigendRole.push(e.dragData);
  // }
  assignRole(event: CdkDragDrop<any[]>) {
    if (event.previousContainer !== event.container) {
      // Moving item from unassigned roles to assigned roles
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  unAssignRole(event: CdkDragDrop<any[]>) {
    if (event.previousContainer !== event.container) {
      // Moving item from assigned roles to unassigned roles
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

}
